/**
 * Converts a metric ID to its corresponding scale value
 * @param {string} metricId - The metric ID to convert
 * @returns {string} The corresponding scale value
 */
export function getScaleFromMetricId(metricId) {
    switch (metricId) {
      case 'ISIP':
        return 'ISIP_overall_universal';
      case 'PhonologicalAwareness':
        return 'phonAwareScore';
      case 'SightRecognition':
        return 'esriScore';
      case 'ORF':
        return 'equatedWCPM';
      default:
        return metricId;
    }
  } 